import React from "react"
import { ExternalLink } from "components"

export default {
  label: "Program",
  title: "The Program",
  program: [
    {
      day: "Friday",
      date: "October 4",
      theme: "Black Utopia, let's celebrate it!",
      agenda: [
        { time: "12:00pm", desc: "Registration 📋" },
        {
          time: "12:00pm — 1:00pm",
          desc: "Admission lunch 🍔",
          rsvp: "https://admissions.gsd.harvard.edu/portal/Event-Calendar",
        },
        {
          time: "12:00pm — 7:00pm",
          desc: "Playground of Empathy: Immersive Gender Experience",
          rsvp:
            "https://calendly.com/playgroundofempathy/bid?month=2019-10&date=2019-10-06",
        },
        { time: "3:00pm", desc: "The Just City Cypher Room Open House" },
        { time: "4:00pm — 7:30pm", desc: "Dope and Different Exhibit" },
        { time: "5:00pm", desc: "Opening Remarks" },
        { time: "5:30pm", desc: "Opening Keynote: Pierce Freelon" },
        {
          time: "6:30pm — 9:00pm",
          desc: "Beer and Dogs: Black to the Future Co-hosted with Africa GSD",
        },
      ],
    },
    {
      day: "Saturday",
      date: "October 5",
      theme: "Black Justice, let's talk about it!",
      agenda: [
        { time: "8:00am", desc: "Registration 📋" },
        { time: "8:00am", desc: "Breakfast 🥯" },
        { time: "8:45am", desc: "Opening Remarks" },
        {
          time: "9:00am",
          overline: "Session 1",
          desc: "African American Design Nexus",
          about:
            "The African American Design Nexus was launched through the GSD library in 2019. The project honors the legacy of Black designers while exploring “the intersection of design, identity, and practice”. BiD is excited to partner with the Nexus through this rich conversation with four women who have fundamentally shaped the field through their visions for transformative design.",
          speakers: [
            "Felecia Davis",
            "Allison Grace Williams",
            "Diane Jones Allen",
          ],
          moderator: {
            name: "Gabriel Ramos & Mariah Barber",
          },
        },
        {
          time: "9:30am — 6:30pm",
          desc: "Playground of Empathy: Immersive Gender Experience",
          rsvp:
            "https://calendly.com/playgroundofempathy/bid?month=2019-10&date=2019-10-06",
        },
        { time: "9:30pm — 6:30pm", desc: "Dope and Different Exhibit" },
        {
          time: "10:15am",
          overline: "Interlude",
          desc: (
            <ul>
              <li>The Just City Cypher Session</li>
              <li>
                <ExternalLink url="https://www.trill.fit/">
                  TRILLFIT Dance Break
                </ExternalLink>
              </li>
            </ul>
          ),
        },
        {
          time: "11:00am",
          overline: "Session 2",
          desc: "Imagining Black Futures: Designing for the Possible",
          about:
            "From climate change to mass-migration, designers of the future will be faced with unparalleled challenges. Our creativity will be pushed to the brink as we are tasked with designing for realities that have yet to exist. This panel explores the multi-faceted ways that design may rise up to meet the challenges of the future, rooted in not just notions of fear, but possibility.",
          speakers: ["Toni Griffin", "Kenneth Bailey", "Malcolm Davis"],
          moderator: {
            name: "Jha D Williams",
          },
        },
        { time: "12:00pm", desc: "Lunch 🍔" },
        { time: "12:00pm", desc: "Career Fair" },
        {
          time: "1:30pm",
          overline: "Session 3",
          desc:
            "Black Power Meets the Digital: Equity & Justice in Technology and Media",
          about:
            "From techno-chauvinism, to AI systems that do not recognize Black faces, the impact of technology and media on Black communities continues to be profoundly consequential. The following panelists breathe life and insight into how technology and media can be used to create abundance for Black communities, rather than exacerbated oppression. From leveraging biomimicry, to reshaping graphic design, and infusing technology with afrofuturism, this panel explores how Black designers and creatives can harness tech for good.",
          speakers: [
            "Bridgette Wallace",
            "Jerome Harris",
            "Ari Melenciano",
            "Billy Almon",
          ],
          moderator: {
            name: "Ladipo Famodu",
          },
        },
        {
          time: "2:45pm",
          overline: "Interlude",
          desc:
            "Guided Meditation with Kartina Richardson. The Just City Cypher Session 2",
        },
        {
          time: "3:30pm",
          overline: "Session 4",
          desc:
            "The Sanctity of Black Bodies: Creating Spaces for Wellness & Joy",
          about:
            "What is required for Black people to walk through the world liberated, joyful, and healed in the future? Our panelists explore how mental wellness, community-grown wealth, and Black dream-spaces will converge to create a future where the sanctity of our bodies is honored and dignified.",
          speakers: [
            "Denise Shante Brown",
            "Nia Evans",
            "Charles Wallace-Thomas IV",
            "Adolphus Opara",
          ],
          moderator: {
            name: "DeAndrea Nichols",
            url: "https://www.denichols.co/",
          },
        },
        {
          time: "4:45pm",
          overline: "Breakout Workshops",
          desc: (
            <ul>
              <li>BlackSpace</li>
              <li>Designing in Color</li>
              <li>AI in the Loop</li>
            </ul>
          ),
        },
        { time: "5:45pm", desc: "Closing Remarks" },
        {
          time: "6:00pm",
          desc: "Closing Keynote: Deanna Van Buren",
        },
        { time: "9:00pm", desc: "Reception" },
      ],
    },
    {
      day: "Sunday",
      date: "October 6",
      theme: "Black Futurism, let's define it!",
      agenda: [
        { time: "9:00am", desc: "Registration 📋" },
        { time: "9:00am", desc: "Breakfast 🥓" },
        { time: "10:00am", desc: "Opening Remarks" },
        {
          time: "11:00am",
          overline: "Workshops",
          desc: (
            <ul>
              <li>
                Nature-Inspired Futures: Exploring Biomimicry as a tool for
                people of color
              </li>
              <li>Black Quantum Futurism Collective</li>
              <li>The Just City Lab Cypher Session</li>
              <li>BlackSpace</li>
            </ul>
          ),
        },
        { time: "1:00pm", desc: "Conference Closing" },
      ],
    },
  ],
}
